import { Box, StyleSystemProps, TextV2, styled } from '@withjoy/joykit';
import { BrandsMarqueeProps } from './BrandsMarquee';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledContainer = styled(Box)``;
export const StyledTitle = styled(TextV2)``;
export const StyledSubtitle = styled(TextV2)``;

const titleStyles = (variant: BrandsMarqueeProps['variant']): StyleSystemProps => ({
  typographyVariant: variant === 'overview' ? 'hed4' : ['hed2', null, 'hed3'],
  marginX: variant !== 'overview' ? 9 : undefined,
  marginBottom: variant === 'overview' ? 3 : pxToRem(56),
  textAlign: 'center',
  maxWidth: variant !== 'overview' ? { _: pxToRem(233), md: 'none' } : undefined,
});

const subtitleStyles: StyleSystemProps = {
  textAlign: 'center',
  marginBottom: 7,
};

const containerStyles: StyleSystemProps = {
  position: 'relative',
  width: '100%',
};

export const styles = {
  title: titleStyles,
  subtitle: subtitleStyles,
  container: containerStyles,
};
